import { DatePicker, Input, Select, Switch } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AlramInput from "../../../../components/AlramInput";
import TextArea from "antd/es/input/TextArea";
import { PrintCyclenderInput } from "../../../../staff/common/common-functions";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import moment from "moment";

const MainEngineLog = () => {
  const { eng_log_basic_id } = useParams();
  const [cyl_exhaust_temp_for_main, set_cyl_exhaust_temp_for_main] = useState(
    []
  );
  const [cyl_scavenge_box_temp_for_main, set_cyl_scavenge_box_temp_for_main] =
    useState("");
  const [cyl_jacket_water_temp_for_main, set_cyl_jacket_water_temp_for_main] =
    useState("");
  const [
    cyl_piston_cooling_oil_out_temp_for_main,
    set_cyl_piston_cooling_oil_out_temp_for_main,
  ] = useState("");
  const [cyl_fuel_rack_for_main, set_cyl_fuel_rack_for_main] = useState("");
  const [fuel_Oil_Type, set_Fuel_Oil_Type] = useState("");
  const [fuel_index, set_fuel_index] = useState("");
  const [govenor, set_govenor] = useState("");
  const [fuel_oil_inlet, set_fuel_oil_inlet] = useState("");
  const [fuel_oil_inlet_temp, set_fuel_oil_inlet_temp] = useState("");
  const [pressure, set_pressure] = useState("");
  const [starting_air_pressure, set_starting_air_pressure] = useState("");
  const [control_air_pressure, set_control_air_pressure] = useState("");
  const [scavenge_air_inlet_temp, set_scavenge_air_inlet_temp] = useState("");
  const [scavenge_air_pressure, set_scavenge_air_pressure] = useState("");
  const [egb_inlet_temp, set_egb_inlet_temp] = useState("");
  const [egb_outlet_temp, set_egb_outlet_temp] = useState("");
  const [rpm_X_1000, set_Rpm_X_1000] = useState("");
  const [exhaust_in_temp, set_exhaust_in_temp] = useState("");
  const [exhaust_out_temp, set_exhaust_out_temp] = useState("");
  const [air_In, set_Air_In] = useState("");
  const [air_Out, set_Air_Out] = useState("");
  const [lube_oil_in_temp, set_lube_oil_in_temp] = useState("");
  const [lube_oil_out_temp, set_lube_oil_out_temp] = useState("");
  const [lube_oil_in_pressure, set_lube_oil_in_pressure] = useState("");
  const [lube_oil_out_pressure, set_lube_oil_out_pressure] = useState("");
  const [lo_cooling_water_in_temp, set_lo_cooling_water_in_temp] = useState("");
  const [lo_cooling_water_in_pressure, set_lo_cooling_water_in_pressure] =
    useState("");
  const [
    lo_cooler_cooling_water_out_temp,
    set_lo_cooler_cooling_water_out_temp,
  ] = useState("");
  const [
    lo_cooler_cooling_water_out_pressure,
    set_lo_cooler_cooling_water_out_pressure,
  ] = useState("");
  const [lube_oil_inlet_to_engine, set_lube_oil_inlet_to_engine] = useState("");
  const [lube_oil_inlet_to_tc, set_lube_oil_inlet_to_tc] = useState("");
  const [air_cooler_air_in_temp, set_air_cooler_air_in_temp] = useState("");
  const [air_cooler_air_out_temp, set_air_cooler_air_out_temp] = useState("");
  const [ac_cooling_water_in_temp, set_ac_cooling_water_in_temp] = useState("");
  const [ac_cooling_water_out_temp, set_ac_cooling_water_out_temp] =
    useState("");
  const [ac_cooling_water_in_pressure, set_ac_cooling_water_in_pressure] =
    useState("");
  const [ac_cooling_water_out_pressure, set_ac_cooling_water_out_pressure] =
    useState("");
  const [ac_air_in_pressure, set_ac_air_in_pressure] = useState("");
  const [ac_air_out_pressure, set_ac_air_out_pressure] = useState("");
  const [ac_manometer_pressure, set_ac_manometer_pressure] = useState("");
  const [lt_sea_water_in_temp, set_lt_sea_water_in_temp] = useState("");
  const [lt_sea_water_out_temp, set_lt_sea_water_out_temp] = useState("");
  const [lt_sea_water_in_pressure, set_lt_sea_water_in_pressure] = useState("");
  const [lt_sea_water_out_pressure, set_lt_sea_water_out_pressure] =
    useState("");
  const [lt_fresh_water_in_temp, set_lt_fresh_water_in_temp] = useState("");
  const [lt_fresh_water_out_temp, set_lt_fresh_water_out_temp] = useState("");
  const [lt_fresh_water_in_pressure, set_lt_fresh_water_in_pressure] =
    useState("");
  const [lt_fresh_water_out_pressure, set_lt_fresh_water_out_pressure] =
    useState("");
  const [ship_no_of_cylinder, set_ship_no_of_cylinder] = useState(null);
  const [main_engine_number, set_Main_Engine_Number] = useState(1);
  const [engine_Numbers, set_Engine_Number] = useState([1, 2]);
  const [cooling_water_inlet, set_cooling_water_inlet] = useState("");
  const [lube_Oil_Inlet, set_Lube_Oil_Inlet] = useState("");
  const [running_Hour, set_Running_Hour] = useState("");
  const [total_Running_Hour, set_Total_Running_Hour] = useState("");
  const [free_Text, set_Free_Text] = useState("");
  const [other_fuel_oil_type, set_Other_fuel_oil_type] = useState("");
  const [logDate, set_LogDate] = useState(
    moment().format("YYYY-MM-DD HH:mm:ss")
  );
  const [cyl_oil_bn, set_cyl_oil_bn] = useState("");
  const [turbocharger_on_off, set_turbocharger_on_off] = useState(false);
  const [exhaust_in_temp_two, set_exhaust_in_temp_two] = useState("");
  const [exhaust_out_temp_two, set_exhaust_out_temp_two] = useState("");
  const [rpm_X_1000_two, set_Rpm_X_1000_two] = useState("");
  const [air_In_two, set_Air_In_two] = useState("");
  const [air_Out_two, set_Air_Out_two] = useState("");
  const [lube_oil_inlet_to_tc_two, set_lube_oil_inlet_to_tc_two] = useState("");

  // Alarm state change
  const [main_exhaust_temp, set_main_exhaust_temp] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [scavenge_box_temp, set_scavenge_box_temp] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [jacket_water_temp, set_jacket_water_temp] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [piston_cooling_oil_out_temp, set_piston_cooling_oil_out_temp] =
    useState({
      max: null,
      orange: null,
      red: null,
    });
  const [fuel_rack, set_fuel_rack] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [fuel_oil_inlet_alarm, set_fuel_oil_inlet_alarm] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [scavenge_air_inlet, set_scavenge_air_inlet] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [lube_oil_inlet, set_lube_oil_inlet] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [egb_inlet, set_egb_inlet] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [egb_outlet, set_egb_outlet] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [exh_in, set_exh_in] = useState({ max: null, orange: null, red: null });
  const [exh_out, set_exh_out] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [air_in, set_air_in] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [air_out, set_air_out] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [fuel_oil_inlet_to_engine, set_fuel_oil_inlet_to_engine] = useState({
    max: null,
    orange: null,
    red: null,
  });

  const onChangeDateTime = (value) => {
    if (value) {
      set_LogDate(value.format("YYYY-MM-DD HH:mm:ss"));
    } else {
      set_LogDate(null);
    }
  };

  // Alarm state change ended
  const ALARM_VIEW_API = async () => {
    try {
      const FORM_DATA = new FormData();
      const ship_id = JSON.parse(localStorage.getItem("ship_id"));
      FORM_DATA.append("ship_id", ship_id);
      FORM_DATA.append("request_type", "view");
      post(ApiURL.view_alarm_conditions_com, FORM_DATA).then((res) => {
        const alarm_condition_data = res?.alarm_condition_data;
        if (res?.status == true && alarm_condition_data) {
          set_main_exhaust_temp(
            JSON.parse(alarm_condition_data.main_exhaust_temp)
          );
          set_scavenge_box_temp(
            JSON.parse(alarm_condition_data.scavenge_box_temp)
          );
          set_jacket_water_temp(
            JSON.parse(alarm_condition_data.jacket_water_temp)
          );
          set_piston_cooling_oil_out_temp(
            JSON.parse(alarm_condition_data.piston_cooling_oil_out_temp)
          );
          set_fuel_rack(JSON.parse(alarm_condition_data.fuel_rack));
          set_fuel_oil_inlet_alarm(
            JSON.parse(alarm_condition_data.fuel_oil_inlet)
          );
          set_scavenge_air_inlet(
            JSON.parse(alarm_condition_data.scavenge_air_inlet)
          );
          set_lube_oil_inlet(JSON.parse(alarm_condition_data.lube_oil_inlet));
          set_egb_inlet(JSON.parse(alarm_condition_data.egb_inlet));
          set_egb_outlet(JSON.parse(alarm_condition_data.egb_outlet));
          set_exh_in(JSON.parse(alarm_condition_data.exh_in));
          set_exh_out(JSON.parse(alarm_condition_data.exh_out));
          set_air_in(JSON.parse(alarm_condition_data.air_in));
          set_air_out(JSON.parse(alarm_condition_data.air_out));
          set_fuel_oil_inlet_to_engine(
            JSON.parse(alarm_condition_data.fuel_oil_inlet_to_engine)
          );
        } else {
          const errors = res?.errors || {};
        }
      });
    } finally {
    }
  };

  const VIEW_MAIN_DETAILS_LOGBOOK_API = async () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
      FORM_DATA.append("main_engine_number", main_engine_number);
      post(ApiURL.view_main_eng_log_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const main_engine = res?.response_data;
          const cyl_exhaust_temp_for_mainArray =
            main_engine?.cyl_exhaust_temp_for_main
              ? main_engine?.cyl_exhaust_temp_for_main.split(",")
              : "";
          const cyl_scavenge_box_temp_for_mainArray =
            main_engine?.cyl_scavenge_box_temp_for_main
              ? main_engine?.cyl_scavenge_box_temp_for_main.split(",")
              : "";
          const cyl_jacket_water_temp_for_mainArray =
            main_engine?.cyl_jacket_water_temp_for_main
              ? main_engine?.cyl_jacket_water_temp_for_main.split(",")
              : "";
          const cyl_piston_cooling_oil_out_temp_for_mainArray =
            main_engine?.cyl_piston_cooling_oil_out_temp_for_main
              ? main_engine?.cyl_piston_cooling_oil_out_temp_for_main.split(",")
              : "";
          const cyl_fuel_rack_for_mainArray =
            main_engine?.cyl_fuel_rack_for_main
              ? main_engine?.cyl_fuel_rack_for_main.split(",")
              : "";
          set_cyl_exhaust_temp_for_main(
            main_engine?.cyl_exhaust_temp_for_main
              ? cyl_exhaust_temp_for_mainArray
              : Array(ship_no_of_cylinder).fill("")
          );
          set_cyl_scavenge_box_temp_for_main(
            main_engine?.cyl_scavenge_box_temp_for_main
              ? cyl_scavenge_box_temp_for_mainArray
              : Array(ship_no_of_cylinder).fill("")
          );
          set_cyl_jacket_water_temp_for_main(
            main_engine?.cyl_jacket_water_temp_for_main
              ? cyl_jacket_water_temp_for_mainArray
              : Array(ship_no_of_cylinder).fill("")
          );
          set_cyl_piston_cooling_oil_out_temp_for_main(
            main_engine?.cyl_piston_cooling_oil_out_temp_for_main
              ? cyl_piston_cooling_oil_out_temp_for_mainArray
              : Array(ship_no_of_cylinder).fill("")
          );
          set_cyl_fuel_rack_for_main(
            main_engine?.cyl_fuel_rack_for_main
              ? cyl_fuel_rack_for_mainArray
              : Array(ship_no_of_cylinder).fill("")
          );
          set_Fuel_Oil_Type(main_engine?.fuel_oil_type);
          set_fuel_index(main_engine?.fuel_index);
          set_govenor(main_engine?.govenor);
          set_fuel_oil_inlet_temp(main_engine?.fuel_oil_inlet_temp);
          set_pressure(main_engine?.pressure);
          set_starting_air_pressure(main_engine?.starting_air_pressure);
          set_control_air_pressure(main_engine?.control_air_pressure);
          set_scavenge_air_pressure(main_engine?.scavenge_air_pressure);
          set_Rpm_X_1000(main_engine?.rpm_x_1000);
          set_Air_In(main_engine?.air_cooler_air_in);
          set_Air_Out(main_engine?.air_cooler_air_out);
          set_lube_oil_in_temp(main_engine?.lube_oil_in_temp);
          set_lube_oil_out_temp(main_engine?.lube_oil_out_temp);
          set_lube_oil_in_pressure(main_engine?.lube_oil_in_pressure);
          set_lube_oil_out_pressure(main_engine?.lube_oil_out_pressure);
          set_lo_cooling_water_in_temp(main_engine?.lo_cooling_water_in_temp);
          set_lo_cooling_water_in_pressure(
            main_engine?.lo_cooling_water_in_pressure
          );
          set_lo_cooler_cooling_water_out_temp(
            main_engine?.lo_cooling_water_out_temp
          );
          set_lo_cooler_cooling_water_out_pressure(
            main_engine?.lo_cooling_water_out_pressure
          );
          set_lube_oil_inlet_to_tc(main_engine?.lube_oil_inlet_to_tc);
          set_ac_cooling_water_in_temp(main_engine?.ac_cooling_water_in_temp);
          set_ac_cooling_water_out_temp(main_engine?.ac_cooling_water_out_temp);
          set_ac_cooling_water_in_pressure(
            main_engine?.ac_cooling_water_in_pressure
          );
          set_ac_cooling_water_out_pressure(
            main_engine?.ac_cooling_water_out_pressure
          );
          set_ac_air_in_pressure(main_engine?.ac_air_in_pressure);
          set_ac_air_out_pressure(main_engine?.ac_air_out_pressure);
          set_ac_manometer_pressure(main_engine?.ac_manometer_pressure);
          set_lt_sea_water_in_temp(main_engine?.lt_sea_water_in_temp);
          set_lt_sea_water_out_temp(main_engine?.lt_sea_water_out_temp);
          set_lt_sea_water_in_pressure(main_engine?.lt_sea_water_in_pressure);
          set_lt_sea_water_out_pressure(main_engine?.lt_sea_water_out_pressure);
          set_lt_fresh_water_in_temp(main_engine?.lt_fresh_water_in_temp);
          set_lt_fresh_water_out_temp(main_engine?.lt_fresh_water_out_temp);
          set_lt_fresh_water_in_pressure(
            main_engine?.lt_fresh_water_in_pressure
          );
          set_lt_fresh_water_out_pressure(
            main_engine?.lt_fresh_water_out_pressure
          );
          // set_Main_Engine_Number(main_engine?.main_engine_number);
          set_cooling_water_inlet(main_engine?.cooling_water_inlet_pressure);
          set_scavenge_air_inlet_temp(main_engine?.scavenge_air_inlet_temp);
          set_egb_inlet_temp(main_engine?.egb_inlet_temp);
          set_egb_outlet_temp(main_engine?.egb_outlet_temp);
          set_exhaust_in_temp(main_engine?.exhaust_in_temp);
          set_exhaust_out_temp(main_engine?.exhaust_out_temp);
          set_air_cooler_air_in_temp(main_engine?.ac_air_in_temp);
          set_air_cooler_air_out_temp(main_engine?.ac_air_out_temp);
          set_fuel_oil_inlet(main_engine?.fuel_oil_inlet_pressure);
          set_Lube_Oil_Inlet(main_engine?.lube_oil_inlet_temp);
          set_lube_oil_inlet_to_engine(
            main_engine?.lube_oil_inlet_temp_for_main
          );
          set_Running_Hour(main_engine?.main_running_hours);
          set_Total_Running_Hour(main_engine?.main_total_running_hours);
          set_Free_Text(main_engine?.main_comment);
          set_Other_fuel_oil_type(main_engine?.other_fuel_oil_type);
          set_cyl_oil_bn(main_engine?.cyl_oil_bn);
          set_turbocharger_on_off(main_engine?.turbocharger_on_off);
          set_exhaust_in_temp_two(main_engine?.exhaust_in_temp_two);
          set_exhaust_out_temp_two(main_engine?.exhaust_out_temp_two);
          set_Rpm_X_1000_two(main_engine?.rpm_X_1000_two);
          set_Air_In_two(main_engine?.air_In_two);
          set_Air_Out_two(main_engine?.air_Out_two);
          set_lube_oil_inlet_to_tc_two(main_engine?.lube_oil_inlet_to_tc_two);
          set_ship_no_of_cylinder(res?.main_eng_cylinder);
        } else {
          const errors = res?.errors || {};
          console.log("Error ***", errors);
        }
      });
    } catch (error) {
      console.error("Error View logbook:", error);
    }
  };

  useEffect(() => {
    ALARM_VIEW_API();
  }, []);

  useEffect(() => {
    VIEW_MAIN_DETAILS_LOGBOOK_API();
  }, [main_engine_number]);

  return (
    <>
      <div className="white-container">
        <>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Main Engine Number</label>
                <Select
                  value={main_engine_number}
                  placeholder=" -- Select of Main Engine Number  -- "
                  style={{ width: "100%" }}
                  onChange={(value) => {
                    set_Main_Engine_Number(value);
                  }}
                >
                  {engine_Numbers?.map((number) => (
                    <Select.Option key={number} value={number}>
                      {number}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Date & Time</label>
                <DatePicker
                  disabled
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  placeholder="Select Date & Time"
                  value={
                    logDate ? moment(logDate, "YYYY-MM-DD HH:mm:ss") : null
                  }
                  onChange={onChangeDateTime}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>CYL Exhaust Temp (°C)</label>
                <div
                  className="row"
                  style={{
                    margin: "0px 0px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  <PrintCyclenderInput
                    placeholder="Temp"
                    disabled={true}
                    input_number={ship_no_of_cylinder}
                    set_value={set_cyl_exhaust_temp_for_main}
                    values={cyl_exhaust_temp_for_main}
                    alarm_Data={main_exhaust_temp}
                  />
                </div>
              </div>
            </div>
            {/* Scavenge Box Temp */}
            <div className="col-6">
              <div className="input-box">
                <label>Scavenge Box Temp (°C)</label>
                <div
                  className="row"
                  style={{
                    margin: "0px 0px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  <PrintCyclenderInput
                    placeholder="Temp"
                    disabled={true}
                    input_number={ship_no_of_cylinder}
                    set_value={set_cyl_scavenge_box_temp_for_main}
                    values={cyl_scavenge_box_temp_for_main}
                    alarm_Data={scavenge_box_temp}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Jacket Water Temp (°C)</label>
                <div
                  className="row"
                  style={{
                    margin: "0px 0px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  <PrintCyclenderInput
                    placeholder="Temp"
                    disabled={true}
                    input_number={ship_no_of_cylinder}
                    set_value={set_cyl_jacket_water_temp_for_main}
                    values={cyl_jacket_water_temp_for_main}
                    alarm_Data={jacket_water_temp}
                  />
                </div>
              </div>
            </div>
            {/* Fuel Rack */}
            <div className="col-6">
              <div className="input-box">
                <label>Fuel Rack</label>
                <div
                  className="row"
                  style={{
                    margin: "0px 0px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  <PrintCyclenderInput
                    placeholder="Rack"
                    disabled={true}
                    input_number={ship_no_of_cylinder}
                    set_value={set_cyl_fuel_rack_for_main}
                    values={cyl_fuel_rack_for_main}
                    alarm_Data={fuel_rack}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Piston Cooling Oil Out Temp */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Piston Cooling Oil Out Temp (°C)</label>
                <div
                  className="row"
                  style={{
                    margin: "0px 0px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  <PrintCyclenderInput
                    placeholder="Temp"
                    disabled={true}
                    input_number={ship_no_of_cylinder}
                    set_value={set_cyl_piston_cooling_oil_out_temp_for_main}
                    values={cyl_piston_cooling_oil_out_temp_for_main}
                    alarm_Data={piston_cooling_oil_out_temp}
                  />
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>CYL oil BN</label>
                <Input
                  disabled
                  value={cyl_oil_bn}
                  placeholder="CYL oil BN"
                  onChange={(e) => set_cyl_oil_bn(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Running Hour */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Running Hour</label>
                <Input
                  disabled
                  value={running_Hour}
                  placeholder="Running Hour "
                  onChange={(e) => set_Running_Hour(e.target.value)}
                />
              </div>
            </div>
            {/* Total Running Hour */}
            <div className="col-6">
              <div className="input-box">
                <label>Total Running Hour</label>
                <Input
                  disabled
                  value={total_Running_Hour}
                  placeholder="Total Running Hour"
                  onChange={(e) => {
                    set_Total_Running_Hour(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          {/* Fuel index */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Fuel index</label>
                <Input
                  disabled
                  value={fuel_index}
                  placeholder="Fuel index"
                  onChange={(e) => set_fuel_index(e.target.value)}
                />
              </div>
            </div>
            {/* Governor */}
            <div className="col-6">
              <div className="input-box">
                <label>Governor</label>
                <Input
                  disabled
                  value={govenor}
                  placeholder="Governor"
                  onChange={(e) => {
                    set_govenor(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          {/* Fuel oil inlet  */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Pressure</label>
                <Select
                  disabled
                  value={pressure}
                  placeholder=" -- Select of Pressure  -- "
                  style={{ width: "100%" }}
                  onChange={(value) => set_pressure(value)}
                >
                  <Select.Option value="Bar">Bar</Select.Option>
                  <Select.Option value="Pascal">Pascal</Select.Option>
                </Select>
              </div>
            </div>
            {/* Fuel Oil Inlet Temp */}
            <div className="col-6">
              <div className="input-box">
                <label>Fuel Oil Inlet Temp (°C)</label>

                <AlramInput
                  disabled={true}
                  value={fuel_oil_inlet_temp}
                  placeholder="Fuel Oil Inlet temp"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue > Number(fuel_oil_inlet_alarm?.max)) return;
                    set_fuel_oil_inlet_temp(e.target.value);
                  }}
                  alarm_Data={fuel_oil_inlet_alarm}
                />
              </div>
            </div>
          </div>

          {/* Pressure */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Fuel oil inlet Pressure (Bar)</label>
                <AlramInput
                  disabled={true}
                  value={fuel_oil_inlet}
                  placeholder="Fuel oil inlet Pressure (Bar)"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue > Number(fuel_oil_inlet_to_engine?.max))
                      return;
                    set_fuel_oil_inlet(newValue);
                  }}
                  alarm_Data={fuel_oil_inlet_to_engine}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Fuel Oil Type</label>
                <Select
                  disabled
                  value={fuel_Oil_Type}
                  placeholder=" -- Select of  Fuel Oil Type  -- "
                  style={{ width: "100%" }}
                  onChange={(value) => set_Fuel_Oil_Type(value)}
                >
                  <Select.Option value="VLSFO">VLSFO</Select.Option>
                  <Select.Option value="LSMGO">LSMGO</Select.Option>
                  <Select.Option value="HSFO">HSFO</Select.Option>
                  <Select.Option value="Other">Other</Select.Option>
                </Select>
              </div>
            </div>
          </div>
          {fuel_Oil_Type === "Other" && (
            <div className="row">
              <div className="col-6"></div>
              <div className="col-6">
                <div className="input-box">
                  <label>Other fuel oil type</label>
                  <Input
                    disabled
                    value={other_fuel_oil_type}
                    placeholder="Other fuel oil type"
                    onChange={(e) => {
                      set_Other_fuel_oil_type(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
          )}

          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>LO inlet Pr to Engine</label>
                <Input
                  disabled
                  value={lube_oil_inlet_to_engine}
                  placeholder="LO inlet Pr to Engine"
                  onChange={(e) => set_lube_oil_inlet_to_engine(e.target.value)}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>LO temp inlet to Main engine</label>
                <AlramInput
                  disabled={true}
                  value={lube_Oil_Inlet}
                  placeholder="LO temp inlet to Main engine"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue > Number(lube_oil_inlet?.max)) return;
                    set_Lube_Oil_Inlet(e.target.value);
                  }}
                  alarm_Data={lube_oil_inlet}
                />
              </div>
            </div>
          </div>

          {/* Starting Air Pressure */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Starting Air Pressure (Bar)</label>
                <Input
                  disabled
                  value={starting_air_pressure}
                  placeholder="Starting air pressure"
                  onChange={(e) => {
                    set_starting_air_pressure(e.target.value);
                  }}
                />
              </div>
            </div>
            {/* Control Air Pressure */}
            <div className="col-6">
              <div className="input-box">
                <label>Control Air Pressure (Bar)</label>
                <Input
                  disabled
                  value={control_air_pressure}
                  placeholder="Control Air Pressure"
                  onChange={(e) => set_control_air_pressure(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Scavenge Air Inlet Temp */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Scavenge Air Inlet Temp</label>
                <AlramInput
                  disabled={true}
                  value={scavenge_air_inlet_temp}
                  placeholder="Scavenge Air Inlet Temp"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue > Number(scavenge_air_inlet?.max)) return;
                    set_scavenge_air_inlet_temp(e.target.value);
                  }}
                  alarm_Data={scavenge_air_inlet}
                />
              </div>
            </div>
            {/* Scavenge Air Pressure */}
            <div className="col-6">
              <div className="input-box">
                <label>Scavenge Air Pressure (Bar)</label>
                <Input
                  disabled
                  value={scavenge_air_pressure}
                  placeholder="Scavenge air pressure (Bar)"
                  onChange={(e) => set_scavenge_air_pressure(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Egb Inlet Temp */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>EGB Inlet Temp</label>

                <AlramInput
                  disabled={true}
                  value={egb_inlet_temp}
                  placeholder=" EGB Inlet temp"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue > Number(egb_inlet?.max)) return;
                    set_egb_inlet_temp(e.target.value);
                  }}
                  alarm_Data={egb_inlet}
                />
              </div>
            </div>
            {/* EGB Outlet Temp*/}
            <div className="col-6">
              <div className="input-box">
                <label>EGB Outlet Temp</label>

                <AlramInput
                  disabled={true}
                  value={egb_outlet_temp}
                  placeholder="EGB Outlet temp"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue > Number(egb_outlet?.max)) return;
                    set_egb_outlet_temp(e.target.value);
                  }}
                  alarm_Data={egb_outlet}
                />
              </div>
            </div>
          </div>

          <h3>Turbocharger Number 1</h3>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Exhaust In Temp (°C)</label>

                <AlramInput
                  disabled={true}
                  value={exhaust_in_temp}
                  placeholder="Exhaust in temp (°C)"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue > Number(exh_in?.max)) return;
                    set_exhaust_in_temp(e.target.value);
                  }}
                  alarm_Data={exh_in}
                />
              </div>
            </div>
            {/* Exhaust  Out Temp*/}
            <div className="col-6">
              <div className="input-box">
                <label>Exhaust Out Temp (°C)</label>
                <AlramInput
                  disabled={true}
                  value={exhaust_out_temp}
                  placeholder="Exhaust Out temp (°C)"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue > Number(exh_out?.max)) return;
                    set_exhaust_out_temp(e.target.value);
                  }}
                  alarm_Data={exh_out}
                />
              </div>
            </div>
          </div>
          {/* common Inputs */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>RPM X 1000</label>
                <Input
                  disabled
                  value={rpm_X_1000}
                  placeholder="rpm X 1000"
                  onChange={(e) => {
                    set_Rpm_X_1000(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Inlet To TC (°C)</label>
                <Input
                  disabled
                  value={lube_oil_inlet_to_tc}
                  placeholder="Inlet To TC"
                  onChange={(e) => set_lube_oil_inlet_to_tc(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="row" style={{ padding: "10px" }}>
            <h3>Turbocharger Number 2</h3>
            <Switch
              disabled
              value={turbocharger_on_off}
              onChange={(value) => {
                set_turbocharger_on_off(value);
              }}
              checkedChildren="On"
              unCheckedChildren="Off"
              style={{
                backgroundColor: turbocharger_on_off ? "green" : "red",
                marginLeft: "10px",
              }}
            />
          </div>
          {turbocharger_on_off && (
            <>
              <div className="row">
                <div className="col-6">
                  <div className="input-box">
                    <label>Exhaust In Temp (°C)</label>

                    <AlramInput
                      disabled
                      value={exhaust_in_temp_two}
                      placeholder="Exhaust in temp (°C)"
                      onChange={(e) => {
                        const newValue = e.target.value;
                        if (newValue > Number(exh_in?.max)) return;
                        set_exhaust_in_temp_two(e.target.value);
                      }}
                      alarm_Data={exh_in}
                    />
                  </div>
                </div>
                {/* Exhaust  Out Temp*/}
                <div className="col-6">
                  <div className="input-box">
                    <label>Exhaust Out Temp (°C)</label>
                    <AlramInput
                      disabled
                      value={exhaust_out_temp_two}
                      placeholder="Exhaust Out temp (°C)"
                      onChange={(e) => {
                        const newValue = e.target.value;
                        if (newValue > Number(exh_out?.max)) return;
                        set_exhaust_out_temp_two(e.target.value);
                      }}
                      alarm_Data={exh_out}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-6">
                  <div className="input-box">
                    <label>RPM X 1000</label>
                    <Input
                      disabled
                      value={rpm_X_1000_two}
                      placeholder="rpm X 1000"
                      onChange={(e) => {
                        set_Rpm_X_1000_two(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <div className="input-box">
                    <label>Inlet To TC (°C)</label>
                    <Input
                      disabled
                      value={lube_oil_inlet_to_tc_two}
                      placeholder="Inlet To TC (°C)"
                      onChange={(e) =>
                        set_lube_oil_inlet_to_tc_two(e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          <h3>Lube Oil Cooler</h3>
          <div className="row">
            {/*Lube oil in Temp */}
            <div className="col-6">
              <div className="input-box">
                <label>in Temp (°C)</label>
                <Input
                  disabled
                  value={lube_oil_in_temp}
                  placeholder=" in temp (°C)"
                  onChange={(e) => {
                    set_lube_oil_in_temp(e.target.value);
                  }}
                />
              </div>
            </div>
            {/* Lube oil out Temp*/}
            <div className="col-6">
              <div className="input-box">
                <label>out Temp (°C)</label>
                <Input
                  disabled
                  value={lube_oil_out_temp}
                  placeholder=" out temp (°C)"
                  onChange={(e) => {
                    set_lube_oil_out_temp(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row">
            {/* lube oil in pressure */}
            <div className="col-6">
              <div className="input-box">
                <label>In pressure (bar)</label>
                <Input
                  disabled
                  value={lube_oil_in_pressure}
                  placeholder=" In Pressure (bar)"
                  onChange={(e) => {
                    set_lube_oil_in_pressure(e.target.value);
                  }}
                />
              </div>
            </div>
            {/* lube oil out pressure */}
            <div className="col-6">
              <div className="input-box">
                <label>out pressure (Bar)</label>
                <Input
                  disabled
                  value={lube_oil_out_pressure}
                  placeholder=" out pressure (Bar)"
                  onChange={(e) => {
                    set_lube_oil_out_pressure(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row">
            {/*Lo cooling water in Temp*/}
            <div className="col-6">
              <div className="input-box">
                <label>Cooling water in Temp (°C)</label>
                <Input
                  disabled
                  value={lo_cooling_water_in_temp}
                  placeholder=" cooling water in Temp (°C)"
                  onChange={(e) => {
                    set_lo_cooling_water_in_temp(e.target.value);
                  }}
                />
              </div>
            </div>
            {/* lo cooling water in pressure */}
            <div className="col-6">
              <div className="input-box">
                <label>Cooling water in pressure (Bar)</label>
                <Input
                  disabled
                  value={lo_cooling_water_in_pressure}
                  placeholder="cooling water in pressure (Bar)"
                  onChange={(e) => {
                    set_lo_cooling_water_in_pressure(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          {/*Lo cooler cooling water out Temp*/}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Cooling water out Temp (°C)</label>
                <Input
                  disabled
                  value={lo_cooler_cooling_water_out_temp}
                  placeholder="Cooling water out temp (°C)"
                  onChange={(e) => {
                    set_lo_cooler_cooling_water_out_temp(e.target.value);
                  }}
                />
              </div>
            </div>
            {/* lo cooler cooling water out pressure */}
            <div className="col-6">
              <div className="input-box">
                <label>Cooling water out pressure (Bar)</label>
                <Input
                  disabled
                  value={lo_cooler_cooling_water_out_pressure}
                  placeholder=" cooling water out pressure (Bar)"
                  onChange={(e) => {
                    set_lo_cooler_cooling_water_out_pressure(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          <h3>Air Cooler</h3>
          {/*  ac Air In Temp  */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Air In Temp</label>
                <AlramInput
                  disabled
                  value={air_cooler_air_in_temp}
                  placeholder=" Air In temp"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue > Number(air_cooler_air_in_temp?.max)) return;
                    set_air_cooler_air_in_temp(e.target.value);
                  }}
                  alarm_Data={air_out}
                />
              </div>
            </div>
            {/*  ac Air out Temp */}
            <div className="col-6">
              <div className="input-box">
                <label>Air Out Temp</label>

                <AlramInput
                  disabled
                  value={air_cooler_air_out_temp}
                  placeholder=" Air Out Temp"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue > Number(air_cooler_air_out_temp?.max)) return;
                    set_air_cooler_air_out_temp(e.target.value);
                  }}
                  alarm_Data={air_out}
                />
              </div>
            </div>
          </div>

          {/*ac cooling water in Temp */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Cooling water in Temp (°C)</label>
                <Input
                  disabled
                  value={ac_cooling_water_in_temp}
                  placeholder="cooling water in temp (°C)"
                  onChange={(e) => {
                    set_ac_cooling_water_in_temp(e.target.value);
                  }}
                />
              </div>
            </div>
            {/* ac Cooling Water out Temp */}
            <div className="col-6">
              <div className="input-box">
                <label>Cooling Water out Temp (°C)</label>
                <Input
                  disabled
                  value={ac_cooling_water_out_temp}
                  placeholder=" cooling water out temp (°C)"
                  onChange={(e) => {
                    set_ac_cooling_water_out_temp(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          {/*Ac cooling water In pressure*/}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Cooling water in Pressure (Bar)</label>
                <Input
                  disabled
                  value={ac_cooling_water_in_pressure}
                  placeholder=" cooling water in pressure (Bar)"
                  onChange={(e) => {
                    set_ac_cooling_water_in_pressure(e.target.value);
                  }}
                />
              </div>
            </div>
            {/*Ac cooling water out pressure*/}
            <div className="col-6">
              <div className="input-box">
                <label>Cooling water out Pressure (Bar)</label>
                <Input
                  disabled
                  value={ac_cooling_water_out_pressure}
                  placeholder=" cooling water out pressure (Bar)"
                  onChange={(e) => {
                    set_ac_cooling_water_out_pressure(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          {/* ac air in pressure*/}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Air in Pressure (Bar)</label>
                <Input
                  disabled
                  value={ac_air_in_pressure}
                  placeholder=" air in pressure (Bar)"
                  onChange={(e) => {
                    set_ac_air_in_pressure(e.target.value);
                  }}
                />
              </div>
            </div>
            {/*ac air out pressure */}
            <div className="col-6">
              <div className="input-box">
                <label>Air Out Pressure (Bar)</label>
                <Input
                  disabled
                  value={ac_air_out_pressure}
                  placeholder=" air out pressure (Bar)"
                  onChange={(e) => {
                    set_ac_air_out_pressure(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          {/* ac manometer pressure */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Manometer Pressure</label>
                <Input
                  disabled
                  value={ac_manometer_pressure}
                  placeholder=" manometer pressure "
                  onChange={(e) => {
                    set_ac_manometer_pressure(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Cooling Water Inlet (Bar)</label>
                <Input
                  disabled
                  value={cooling_water_inlet}
                  placeholder=" cooling water inlet (Bar)"
                  onChange={(e) => {
                    set_cooling_water_inlet(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          <h3>Low Temperature</h3>
          <div className="row">
            {/*Lt sea water in Temp */}
            <div className="col-6">
              <div className="input-box">
                <label>Sea Water In Temp (°C)</label>
                <Input
                  disabled
                  value={lt_sea_water_in_temp}
                  placeholder=" sea water in temp (°C)"
                  onChange={(e) => {
                    set_lt_sea_water_in_temp(e.target.value);
                  }}
                />
              </div>
            </div>
            {/*Lt sea water out Temp */}
            <div className="col-6">
              <div className="input-box">
                <label>Sea Water Out Temp (°C)</label>
                <Input
                  disabled
                  value={lt_sea_water_out_temp}
                  placeholder=" sea water out  temp (°C)"
                  onChange={(e) => {
                    set_lt_sea_water_out_temp(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          {/* Lt sea water in pressure */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Sea Water In Pressure (Bar)</label>
                <Input
                  disabled
                  value={lt_sea_water_in_pressure}
                  placeholder=" sea water in pressure (Bar)"
                  onChange={(e) => {
                    set_lt_sea_water_in_pressure(e.target.value);
                  }}
                />
              </div>
            </div>
            {/* Lt sea water out pressure */}
            <div className="col-6">
              <div className="input-box">
                <label>Sea Water Out Pressure (Bar)</label>
                <Input
                  disabled
                  value={lt_sea_water_out_pressure}
                  placeholder=" sea water out pressure (Bar)"
                  onChange={(e) => {
                    set_lt_sea_water_out_pressure(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          {/* Lt fresh water in Temp */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Fresh Water In Temp (°C)</label>
                <Input
                  disabled
                  value={lt_fresh_water_in_temp}
                  placeholder=" fresh  water in  temp (°C)"
                  onChange={(e) => {
                    set_lt_fresh_water_in_temp(e.target.value);
                  }}
                />
              </div>
            </div>
            {/*Lt fresh water out Temp */}
            <div className="col-6">
              <div className="input-box">
                <label>Fresh Water Out Temp (°C)</label>
                <Input
                  disabled
                  value={lt_fresh_water_out_temp}
                  placeholder=" fresh water out temp (°C)"
                  onChange={(e) => {
                    set_lt_fresh_water_out_temp(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          {/* Lt fresh water in pressure */}
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Fresh Water In Pressure (Bar)</label>
                <Input
                  disabled
                  value={lt_fresh_water_in_pressure}
                  placeholder=" fresh  water in pressure (Bar)"
                  onChange={(e) => {
                    set_lt_fresh_water_in_pressure(e.target.value);
                  }}
                />
              </div>
            </div>
            {/* Lt fresh water out pressure */}
            <div className="col-6">
              <div className="input-box">
                <label>Fresh Water Out Pressure (Bar)</label>
                <Input
                  disabled
                  value={lt_fresh_water_out_pressure}
                  placeholder=" fresh  water out pressure (Bar)"
                  onChange={(e) => {
                    set_lt_fresh_water_out_pressure(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Main Engine Comments</label>
                <TextArea
                  disabled
                  rows={6}
                  placeholder="Main Engine Comments"
                  maxLength={1000}
                  value={free_Text}
                  onChange={(e) => set_Free_Text(e.target.value)}
                />
              </div>
            </div>
          </div>
        </>
      </div>
    </>
  );
};

export default MainEngineLog;
